import { ArticleParagraph1, Fullscreen16 } from '@cian/ui-kit';
import * as React from 'react';

import { ElementInViewport } from '../../common/components/elementInViewport';
import * as styles from './CianLayout.css';
import { Gallery } from './components/Gallery';

export interface ICianLayoutProps {
  imageUrl: string;
  onShownInViewport(): void;
  onFullscreenLayoutOpen(): void;
}

export const CianLayout: React.FC<ICianLayoutProps> = ({ imageUrl, onShownInViewport, onFullscreenLayoutOpen }) => {
  const [isGalleryOpen, setIsGalleryOpen] = React.useState(false);
  const [isShownInViewport, setIsShownInViewport] = React.useState(false);
  const imageAlt = 'Планировка этой квартиры по данным Циан';

  const openGallery = React.useCallback(() => {
    setIsGalleryOpen(true);
    onFullscreenLayoutOpen();
  }, [onFullscreenLayoutOpen]);

  const handleGalleryClose = React.useCallback(() => {
    setIsGalleryOpen(false);
  }, []);

  const handleElementInViewportChange = React.useCallback(
    (visible: boolean) => {
      if (visible && !isShownInViewport) {
        onShownInViewport();
        setIsShownInViewport(true);
      }
    },
    [isShownInViewport, setIsShownInViewport, onShownInViewport],
  );

  return (
    <ElementInViewport onChange={handleElementInViewportChange}>
      <div className={styles['container']}>
        <div className={styles['header']}>
          <ArticleParagraph1 fontWeight="bold">Планировка этой квартиры</ArticleParagraph1>
          <ArticleParagraph1 color="gray40_100">По данным Циан</ArticleParagraph1>
        </div>
        <div className={styles['body']}>
          <img className={styles['image']} src={imageUrl} alt={imageAlt} onClick={openGallery} />
          <button
            className={styles['fullscreen-button']}
            aria-label="Открыть планировку на весь экран"
            onClick={openGallery}
          >
            <Fullscreen16 color="primary_100" />
          </button>
        </div>
        {isGalleryOpen && <Gallery imageUrl={imageUrl} imageAlt={imageAlt} onClose={handleGalleryClose} />}
      </div>
    </ElementInViewport>
  );
};

CianLayout.displayName = 'CianLayout';
